import { makeStyles } from '@material-ui/core'
import React from 'react'
import PropTypes from 'prop-types'

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '2rem',
    padding: '1rem'
  }
}))

const FeaturedFiltersList = ({ children }) => {
  const classes = useStyles()
  return (
    <div className={classes.container}>
      {children}
    </div>
  )
}

FeaturedFiltersList.propTypes = {
  children: PropTypes.node.isRequired
}

export default FeaturedFiltersList
